<template>
  <div v-if="loading">
    Loading rates from store...
  </div>
  <div v-else>
      <div class="debug">
        <p>header = {{ header }}</p>
        <p>tableData.length = {{ tableData.length }}</p>
        <p>colWidths = {{ colWidths }}</p>
        <p>filtered.length = {{ filtered.length }}</p>
        <p>search = {{ search }}</p>
    </div>
  <FilterTable
    :header="header"
    :data="ratesTableData"
    :columnWidths="colWidths"

    @rowClicked="printRow"
    v-model:filtered="filtered"
    v-model:search="search"
  >
  </FilterTable>

  <div v-if="currentGroup === 'admin' || currentGroup === 'standard'" class="btn-row-left">
    <FormBtn :name="'Download all Rates'" @clicked="downloadAllRates"></FormBtn>
    <FormBtn :name="'Refresh Table'" @clicked="rates.fetchAllRates"></FormBtn>
  </div>


  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useInvoiceStore, useUserStore, useRatesStore } from '@/stores'
import type { Invoice } from '@/types/types'
import router from '@/router'
import { FormBtn } from '@/components/form'
import { FilterTable } from '@/components'
import { useAllCsvDownload } from '@/composables/All-csv-download'
import { useRatesTableFilter } from '@/composables/Rates-table-filter'
import { invoiceRateSchema } from '@/types/types'
import { storeToRefs } from 'pinia'

const rates = useRatesStore();
const invoices = useInvoiceStore()
const userStore = useUserStore()
const { currentGroup } = storeToRefs(userStore)
const { tableData } = storeToRefs(rates);
//const allRates = ref<Array<any>>([])
const header = ['id', 'description', 'pileCount', 'rate1', 'rate2', 'notes']
const colWidths = [8, 8, 8,8,8,30]

const ratesTableData = computed(()=>{
  return JSON.parse(JSON.stringify(tableData.value));
})

const loading = computed(()=>{
  return rates.loading;
})

//allRates.value = await invoices.getAllRates();

let searchJson = {}
header?.forEach((col) => {
  searchJson[col] = ''
})
const search = ref(searchJson)
//const { filtered } = useInvoiceTableFilter(allInvoices.value, search)
const { filtered } = useRatesTableFilter(ratesTableData, search);

const ratesHeader = [
  'id',
  'created_on',
  'created_by',
  'modified_on',
  'description',
  'pileCount',
  'rate1',
  'rate2',
  'notes'
]
//add projectCount field to customerSchema
const { downloadAllCsv } = useAllCsvDownload(
  ratesTableData,
  invoiceRateSchema,
  ratesHeader,
  'Rates'
)

async function downloadAllRates(){
  await rates.fetchAllRates();
  await downloadAllCsv();
}

function printRow(item: Invoice) {
  console.log('printRow..does nothing')
  console.log(JSON.stringify(item))
  //console.log("...pushing router to project_details");
  //router.push(`/projects/${item.projectId.toString()}/invoices/${item.id?.toString()}`)
}
</script>
